export function validLocale (locale) {
  const validLocales = ['de', 'de-DE', 'en', 'en-GB', 'en-US', 'fr', 'fr-FR']
  if (!validLocales.includes(locale)) {
    // Fallback to default locale, if the specified locale is not valid
    locale = 'de-DE'
  }
  return locale
}

export function formatPeriod (period) {
  period = period.toString()
  if (period.length === 4) {
    return period
  } else if (period.length === 5) {
    return period.slice(0, 4) + '-Q' + period.slice(4)
  } else if (period.length === 6) {
    return period.slice(0, 4) + '-' + period.slice(4)
  }
}

export function formatNumber (userLocale, number, decimals) {
  userLocale = validLocale(userLocale)
  let formattedNumber = ''

  if (number !== '') {
    formattedNumber = parseFloat(number).toLocaleString(userLocale, { minimumFractionDigits: decimals, maximumFractionDigits: decimals })
  }

  return formattedNumber
}

export function formatInputNumber (userLocale, number, decimals) {
  userLocale = validLocale(userLocale)

  let formattedNumber = ''

  number = number.trim()
  if (number !== '') {
    if (userLocale === 'de' || userLocale === 'de-DE') {
      number = number.toString().replace(',', '|')
      number = number.toString().replace('.', ',')
      number = number.toString().replace('|', '.')
    }
    if (userLocale === 'fr' || userLocale === 'fr-FR') {
      number = number.toString().replace(',', '.')
    }

    const regEx = /[^0-9.-]/g
    number = number.toString().replace(regEx, '')
    if (number !== '') {
      formattedNumber = parseFloat(number).toLocaleString(userLocale, { minimumFractionDigits: decimals, maximumFractionDigits: decimals })
    }
  }

  return formattedNumber
}

export function unFormatNumber (userLocale, number) {
  userLocale = validLocale(userLocale)

  let unFormattedNumber = ''

  if (number && number !== '') {
    number = number.toString()
    if (userLocale === 'de' || userLocale === 'de-DE') {
      number = number.toString().replace(',', '|')
      number = number.toString().replace('.', '')
      number = number.toString().replace('|', '.')
    }
    if (userLocale === 'fr' || userLocale === 'fr-FR') {
      number = number.toString().replace(',', '.')
    }

    const regEx = /[^0-9.-]/g
    number = number.toString().replace(regEx, '')
    unFormattedNumber = parseFloat(number)
  }

  return unFormattedNumber
}

export function formatDate (userLocale, date) {
  userLocale = validLocale(userLocale)

  let standardDate = ''
  const yyyy = date.getFullYear()
  const mm = date.getMonth() + 1
  const dd = date.getDate()

  if (userLocale === 'de' || userLocale === 'de-DE') {
    standardDate = dd.toString().padStart(2, '0') + '.' + mm.toString().padStart(2, '0') + '.' + yyyy
  }
  if (userLocale === 'en' || userLocale === 'en-GB') {
    standardDate = dd.toString().padStart(2, '0') + '/' + mm.toString().padStart(2, '0') + '/' + yyyy
  }
  if (userLocale === 'en-US') {
    standardDate = mm + '/' + dd + '/' + yyyy
  }
  if (userLocale === 'fr' || userLocale === 'fr-FR') {
    standardDate = dd.toString().padStart(2, '0') + '/' + mm.toString().padStart(2, '0') + '/' + yyyy
  }
  return standardDate
}

export function unFormatDate (userLocale, date) {
  userLocale = validLocale(userLocale)

  let standardDate = ''
  if (userLocale === 'de' || userLocale === 'de-DE') {
    const dateComponents = date.split('.')
    standardDate = dateComponents[2] + '-' + dateComponents[1] + '-' + dateComponents[0]
  }
  if (userLocale === 'en' || userLocale === 'en-GB') {
    const dateComponents = date.split('/')
    standardDate = dateComponents[2] + '-' + dateComponents[1] + '-' + dateComponents[0]
  }
  if (userLocale === 'en-US') {
    const dateComponents = date.split('/')
    standardDate = dateComponents[2] + '-' + dateComponents[0].padStart(2, '0') + '-' + dateComponents[1].padStart(2, '0')
  }
  if (userLocale === 'fr' || userLocale === 'fr-FR') {
    const dateComponents = date.split('/')
    standardDate = dateComponents[2] + '-' + dateComponents[1] + '-' + dateComponents[0]
  }
  return standardDate
}

export function getTodayIso () {
  const today = new Date()
  const yyyy = today.getFullYear()
  const mm = String(today.getMonth() + 1).padStart(2, '0')
  const dd = String(today.getDate()).padStart(2, '0')
  return `${yyyy}-${mm}-${dd}`
}

export function getDevColor (actual, plan, statusDeviation, statusYellow) {
  let color = 'bg-transparent text-black'

  if (!plan) {
    return color
  }

  if (statusDeviation === 'H') {
    if (actual >= plan) {
      color = 'bg-success-subtle text-black'
    } else if (actual < plan * (1 - (statusYellow / 100))) {
      color = 'bg-danger-subtle text-black'
    } else {
      color = 'bg-warning-subtle text-black'
    }
  }
  if (statusDeviation === 'L') {
    if (actual <= plan) {
      color = 'bg-success-subtle text-black'
    } else if (actual > plan * (1 + (statusYellow / 100))) {
      color = 'bg-danger-subtle text-black'
    } else {
      color = 'bg-warning-subtle text-black'
    }
  }
  return color
}

export function cleanNodeName (nodeName) {
  nodeName = nodeName.replace(/^(-\s)+/, '').trim()
  return nodeName
}

// Extrahiert aus Nachname, Vorname die Initialen VN
export function getInitials (fullName) {
  if (!fullName) return ''
  const [lastName, firstName] = fullName.split(',').map(s => s.trim())
  const lastInitial = lastName?.charAt(0).toUpperCase() || ''
  const firstInitial = firstName?.charAt(0).toUpperCase() || ''
  return firstInitial + lastInitial
}

// Prüft auf gültige Zahl inkl. 0
export function isValidNumber (value) {
  if (value === null || value === undefined) return false
  if (value === '') return false

  const num = Number(value)
  return Number.isFinite(num)
}
